<template>
  <form>
    <div @click="addNew = true" class="add">
      <span class="mck">L</span>
      <p>Добавете бележка/събитие</p>
    </div>

    <table class="table" v-if="eventLogs && eventLogs.length">
      <thead>
        <tr>
          <th>ДАТА</th>
          <th>БЕЛЕЖКА</th>
          <th>ОПРАВЕНО</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(log, index) of eventLogs"
          :class="{ 'tr--done': log.endedAt }"
          :key="`${index} - ${log.note}`"
        >
          <td>
            <section class="log-dates">
              <div class="log-dates_date">
                <span class="mck">M</span>
                <p>
                  <strong>{{
                    format(new Date(log.date), "dd.MM.yyyy")
                  }}</strong>
                </p>
              </div>

              <div
                v-if="log.endedAt"
                class="log-dates_date log-dates_date--done"
              >
                <span class="mck3">I</span>
                <p>
                  <strong>{{
                    format(new Date(log.endedAt), "dd.MM.yyyy")
                  }}</strong>
                </p>
              </div>
            </section>
          </td>
          <td>{{ log.note }}</td>
          <td>
            <TheInput
              type="checkbox"
              :value="log.endedAt"
              @change="toggleDone(index, $event)"
            />
          </td>
        </tr>
      </tbody>
    </table>

    <TheModal
      v-if="addNew"
      size="medium"
      @close="addNew = false"
      @save="saveEvent"
    >
      <TheInput
        label="БЕЛЕЖКА/СЪБИТИЕ КЪМ ИНВЕНТАРА"
        placeholder="Свободен текст (до 100 знака)"
        :dark="true"
        type="textarea"
        maxlength="100"
        v-model="newEventNote"
        textareaRows="5"
      />
    </TheModal>
  </form>
</template>

<script>
import TheInput from "@/components/TheInput.vue";
import TheModal from "@/components/shared/TheModal.vue";
import { format } from "date-fns";

export default {
  props: ["inventory", "type", "logs"],
  components: { TheInput, TheModal },
  computed: {
    eventLogs() {
      return this.logs.filter((l) => l.isEvent);
    },
  },
  data() {
    return { format, addNew: false, newEventNote: "" };
  },
  methods: {
    toggleDone(index, v) {
      let value = v ? new Date() : undefined;
      this.$set(this.eventLogs[index], "endedAt", value);
    },
    saveEvent() {
      if (this.newEventNote) {
        if (!this.logs) this.$set(this.inventory, "logs", []);
        this.addNew = false;

        this.logs.push({
          note: this.newEventNote,
          isEvent: true,
          date: new Date(),
        });

        this.newEventNote = "";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.log-dates {
  display: flex;
  gap: 5px;
  flex-direction: column;

  .log-dates_date {
    align-items: center;
    display: flex;
    gap: 5px;

    > span {
      font-size: 14px;
    }

    &.log-dates_date--done {
      color: #1ba933;
    }
  }
}
</style>
